import I18n from 'i18n-js';
import { bool, func, string } from 'prop-types';

import BottomPopupWithTransition from '~/components/BottomPopupWithTransition';
import Body from '~/components/DailyTasksView/DailyRewardPopupsBody';
import Footer from '~/components/DailyTasksView/DailyTiles/Tile/DailyReminderPopup/Footer';

import tab from '~/assets/images/daily/tab.svg';

export default function DailyReminder({ popupGradient, show, toggleShow }) {
  return (
    <BottomPopupWithTransition
      banner={I18n.t('DailyView_bc')}
      body={
        <Body
          description={I18n.t('DailyView_reminder')}
          image={{
            alt: 'tab',
            icon: true,
            src: tab,
          }}
          title={I18n.t('DailyView_reminder_headline')}
        />
      }
      footer={<Footer toggleShow={toggleShow} />}
      show={show}
      onClose={toggleShow}
      style={{ background: `linear-gradient(${popupGradient})` }}
    />
  );
}

DailyReminder.propTypes = {
  show: bool.isRequired,
  toggleShow: func.isRequired,
  popupGradient: string.isRequired,
};
